<template>
  <div class="result-item" v-for="(job, index) in applicationJobs" :key="index" @click="showDetail(job.id)">
    <!-- <div class="job-info"> -->
    <!-- <div class="image_wrapper" data-testid="directions-61" @click="userApplicationsInfoModalOpen(job.jobPharmacy)">
        <el-avatar :size="'small'" shape="square" :src="job.image" v-if="job.image" />
        <el-avatar :size="'small'" class="avatar-job" shape="square"
          icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
      </div>
      <div class="job-detail">
        <div class="job-title">{{ job.title }}</div>
        <div class="job-poster">{{ job.poster }}</div>
        <div class="job-location">{{ job.location }}</div>
        <div class="job-category">{{ job.category }}</div>
      </div> -->
    <div class="job-image-title">
      <div class="image_wrapper" data-testid="directions-61" @click="userApplicationsInfoModalOpen(job.jobPharmacy)">
        <el-avatar :size="'small'" shape="square" :src="job.image" v-if="job.image" />
        <el-avatar :size="'small'" class="avatar-job" shape="square"
          icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
      </div>
      <div class="job-detail-main">
        <div class="job-title">{{ job.title }}</div>
        <div class="job-poster">{{ job.poster }}</div>
      </div>
      <el-tag class="inverted job-type-tag" :class="job.type">
        {{ job.type }}
      </el-tag>
      <!-- <div class="job-type-label" :class="job.type">{{ job.type }}</div> -->
    </div>
    <div class="badge-wrapper" v-if="job.notifiedStatus && job.notifiedStatus != ''">
      <div class="badge-status" :class="getClass(job.notifiedStatus)">
        {{ job.notifiedStatus }}
      </div>
    </div>
    <!-- <div class="job-type-label-container">
        <div class="job-type-label" :class="job.type">{{ job.type }}</div>
      </div> -->
    <!-- </div> -->
    <div class="job-detail-row-item">
      <div class="d-flex align-items-center gap-2 flex-1">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.9999 11.1917C11.4358 11.1917 12.5999 10.0276 12.5999 8.5917C12.5999 7.15576 11.4358 5.9917 9.9999 5.9917C8.56396 5.9917 7.3999 7.15576 7.3999 8.5917C7.3999 10.0276 8.56396 11.1917 9.9999 11.1917Z"
            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
          <path
            d="M3.01675 7.07484C4.65842 -0.141827 15.3501 -0.133494 16.9834 7.08317C17.9418 11.3165 15.3084 14.8998 13.0001 17.1165C11.3251 18.7332 8.67508 18.7332 6.99175 17.1165C4.69175 14.8998 2.05842 11.3082 3.01675 7.07484Z"
            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
        </svg>
        <div class="job-detail-text">
          {{ job.location }}
        </div>
      </div>
      <div class="d-flex align-items-center gap-2 flex-1" v-if="job.federalPharmacistSupport === 1 && isUS">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.29169 1.66663V18.3333" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
            stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M4.29169 3.33337H13.625C15.875 3.33337 16.375 4.58337 14.7917 6.16671L13.7917 7.16671C13.125 7.83337 13.125 8.91671 13.7917 9.50004L14.7917 10.5C16.375 12.0834 15.7917 13.3334 13.625 13.3334H4.29169"
            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        </svg>


        <div class="job-detail-text" v-if="job.federalPharmacistSupport === 1">Federal Pharmacist Support</div>
      </div>
    </div>

   

    <div class="job-extra-info">
      <el-tag class="inverted">
        <span>Applied {{ job.applied }}</span>
      </el-tag>
    </div>
    <!-- <div class="job-description">
      <p>{{ job.shortDescription }}</p>
    </div>
    <div class="job-applied-date-info">
      <span>Applied {{ job.applied }}</span>
    </div>
    <div class="job-detail-link" data-testid="directions-62" @click="showDetail(job.id)">
      <button class="link-button"><span>Job Details</span> <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.2837 8.11526L5.36238 2.47339C5.26358 2.3792 5.13232 2.32666 4.99582 2.32666C4.85932 2.32666 4.72805 2.3792 4.62926 2.47339L4.62288 2.47976C4.57482 2.52542 4.53655 2.58038 4.51039 2.6413C4.48424 2.70221 4.47076 2.76781 4.47076 2.8341C4.47076 2.9004 4.48424 2.966 4.51039 3.02691C4.53655 3.08783 4.57482 3.14279 4.62288 3.18845L10.1989 8.50095L4.62288 13.8113C4.57482 13.857 4.53655 13.9119 4.51039 13.9729C4.48424 14.0338 4.47076 14.0994 4.47076 14.1657C4.47076 14.232 4.48424 14.2976 4.51039 14.3585C4.53655 14.4194 4.57482 14.4744 4.62288 14.52L4.62925 14.5264C4.72805 14.6206 4.85932 14.6731 4.99582 14.6731C5.13232 14.6731 5.26358 14.6206 5.36238 14.5264L11.2837 8.88451C11.3358 8.8349 11.3772 8.77522 11.4056 8.70911C11.4339 8.64299 11.4485 8.57181 11.4485 8.49989C11.4485 8.42796 11.4339 8.35678 11.4056 8.29067C11.3772 8.22455 11.3358 8.16488 11.2837 8.11526Z"
            fill="#808080" />
        </svg>
      </button>
    </div> -->
  </div>
  <modal-user-application-info :modalName="'userApplicationInfoModal'"
    :options="userApplicationInfoModal"></modal-user-application-info>
</template>

<script>
import { inject, ref } from "vue";
import { useRouter } from "vue-router";
import { PharmacyInfoModal } from "@/modals/modals";
import {  isUSRegion } from '@/helpers/region/regionHelper.js';

export default {
  props: {
    applicationJobs: {
      type: Object,
      required: true,
    },
  },
  components: {
    "modal-user-application-info": PharmacyInfoModal,
  },
  setup() {
    const $router = useRouter();
    const $modals = inject("$modals");
    const userApplicationInfoModal = ref({
      name: "userInfo",
      user: {},
    });
    // const job = ref(props.job);
    const profileImage = "@/assets/img/job-seeker/profile.svg"; // Assuming this path is correct
    const userApplicationsInfoModalOpen = (user) => {
      if (user) {
        userApplicationInfoModal.value.user = user;
      }
      $modals.open("userApplicationInfoModal");
    };
    const showDetail = (jobId) => {
      console.log("🚀 ~ showDetail ~ jobId:", jobId)

      $router.push({
        name: "job_seeker_application_withdraw",
        params: { jobId: jobId } // Assuming job object has an 'id' property
      });
    };
    const isUS = isUSRegion();


    const getClass = (status) => {
      // Convert the status to lowercase for case-insensitive comparison
      const lowercaseStatus = status.toLowerCase();

      // Return class based on status
      return lowercaseStatus;
    };

    const goBack = () => {

      $router.push({
        name: "job_seeker_applications",
      });
    };

    return {
      profileImage,
      showDetail,
      goBack,
      getClass,
      userApplicationInfoModal,
      userApplicationsInfoModalOpen,
      isUS
    };
  }
}
</script>

<style scoped>
/* Component-specific styles go here */
</style>